import gql from 'graphql-tag';

export const UPDATE_AI_CONFIG = gql`
  mutation($input: AIConfigurationInfoInput!) {
    updateAIConfiguration(input: $input) {
      configurations {
        name
        value
      }
      authorizedBy
    }
  }
`;

const UPDATE_AI_FEATURE = gql`
  mutation($input: UpdateAIFeatureInput!) {
    updateAIFeature(input: $input) {
      featureId
      name
      description
      usageCount
      state
      userDefined
      displayIcon
      clientConfigurable
      prompt {
        prompt
      }
      aiFeatureGroup {
        featureGroupId
        name
        description
        enabled
        constant
      }
    }
  }
`;

const UPDATE_SETTINGS_AI_FEATURE = gql`
  mutation($input: UpdateAIFeatureInput!) {
    updateAIFeature(input: $input) {
      clientConfigurable
      clientConfigType
      clients {
        accountId
        name
      }
    }
  }
`;

const UPDATE_AI_FEATURE_GROUP = gql`
  mutation($input: UpdateAIFeatureGroupInput!) {
    updateAIFeatureGroup(input: $input) {
      featureGroupId
      name
      description
      enabled
      constant
    }
  }
`;

const CREATE_AI_FEATURE = gql`
  mutation($input: CreateAIFeatureInput!) {
    createAIFeature(input: $input) {
      featureId
      name
      state
      description
      usageCount
      enabled
      userDefined
      displayIcon
      prompt {
        prompt
      }
      aiFeatureGroup {
        featureGroupId
        name
        description
        enabled
        constant
      }
    }
  }
`;

const CREATE_AI_FEATURE_FEEDBACK = gql`
  mutation($input: CreateAIFeatureFeedbackInput!) {
    createAIFeatureFeedback(input: $input) {
      feedbackId
    }
  }
`;

const DELETE_AI_FEATURE = gql`
  mutation($input: AIFeatureIdentifierInput!) {
    deleteAIFeature(input: $input)
  }
`;

const ADD_AI_AGENT_FEEDBACK = gql`
  mutation($input: AddAIAgentFeedbackInput!) {
    addAIAgentFeedback(input: $input)
  }
`;

const UPDATE_TRIAGE_TICKET = gql`
  mutation(
    $id: ID!
    $priority: String
    $impact: String
    $urgency: String
    $ticketType: String
    $status: String
    $cause: String
    $subcause: String
    $category: String
    $subcategory: String
    $resolutionCode: String
    $techGroup: GroupInput
    $customFields: JSON
    $handledByAIAgent: AIFeatureIdentifierInput
    $form: TicketFormIdentifierInput
  ) {
    updateTicket(
      id: $id
      input: {
        priority: $priority
        impact: $impact
        urgency: $urgency
        ticketType: $ticketType
        status: $status
        cause: $cause
        subcause: $subcause
        category: $category
        subcategory: $subcategory
        resolutionCode: $resolutionCode
        techGroup: $techGroup
        customFields: $customFields
        handledByAIAgent: $handledByAIAgent
        form: $form
      }
    ) {
      displayId
      ticketId
    }
  }
`;

const ONBOARD_AI_AGENT = gql`
  mutation($input: AIAgentOnboardingInput!) {
    onboardAIAgent(input: $input)
  }
`;

export {
  UPDATE_AI_FEATURE,
  UPDATE_SETTINGS_AI_FEATURE,
  UPDATE_AI_FEATURE_GROUP,
  CREATE_AI_FEATURE,
  DELETE_AI_FEATURE,
  CREATE_AI_FEATURE_FEEDBACK,
  ADD_AI_AGENT_FEEDBACK,
  UPDATE_TRIAGE_TICKET,
  ONBOARD_AI_AGENT
};
